import React from 'react';
import propTypes from 'prop-types';
import ItemComponent from '../../UI/Toolbar/ToolbarItems';
import TextItem from './textItem';
import Name from '../../../../cra/src/components/userDocuments/editDocument/editResume/Toolbar/ToolbarItems/name';
import URL from './url';
import ExternalURLComponent from './externalURL';

const Item = (props) => {
  const { listItem, pathName, ImageComponent } = props;
  const { type, className } = listItem;

  return (
    <ItemComponent className={className} pathName={pathName}>
      {
        {
          text: <TextItem {...props} />,
          image: <>{ImageComponent && <ImageComponent {...props} />}</>,
          name: <Name {...props} />,
          url: <URL {...props} />,
          externalURL: <ExternalURLComponent {...props} />,
        }[type]
      }
    </ItemComponent>
  );
};

Item.propTypes = {
  listItem: propTypes.shape({
    type: propTypes.string,
    text: propTypes.string,
    className: propTypes.string,
    icon: propTypes.string,
  }),
};

Item.defaultProps = {
  listItem: { type: '', text: '', className: '', icon: '' },
};

export default Item;
